import React, { useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { FormLabel, Offcanvas } from 'react-bootstrap'
import { PanelFooter, PanelHeader } from 'components/Panel'
import FileUpload from 'components/FileUpload/FileUpload'

// https://www.npmjs.com/package/react-datepicker
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import es from 'date-fns/locale/es';

import "react-datepicker/dist/react-datepicker.css";

function EditarPropiedad(props) {
	const { propiedadOriginal, guardar, setQueMostrar } = props

	registerLocale('es', es)

	const [datos, setDatos] = useState({
		id: propiedadOriginal.id,
		borrador: propiedadOriginal.borrador === '1',
		titulo: propiedadOriginal.titulo,
		contenido: propiedadOriginal.contenido,
		fechaCreacion: new Date(propiedadOriginal.fechaCreacion),
		fecha: new Date(propiedadOriginal.fecha),
		imagen: false,
	})

	const [erroresValidacion, setErroresValidacion] = useState({})

	const handleClose = () => {
		setQueMostrar('')
		setDatos({})
	}

	const handleProcesar = (e) => {
		e.preventDefault()

		const data = {
			...datos,
		}

		if (validarDatos()) {
			guardar(data)
			handleClose()
		}
	}

	const validarDatos = () => {
		const camposRequeridos = ['titulo']
		const nuevosErrores = {}

		camposRequeridos.forEach(campo => {
			if (datos[campo].trim() === '') {
				nuevosErrores[campo] = 'Este es un campo requerido'
			} else {
				nuevosErrores[campo] = null
			}
		})

		const errores = { ...erroresValidacion, ...nuevosErrores }

		setErroresValidacion(errores)

		return Object.keys(errores).filter(elem => errores[elem] !== null).length === 0
	}

	const handleChange = (value, key) => {
		const datosCopia = { ...datos }
		datosCopia[key] = value
		setDatos(prev => datosCopia)
	}

	const handleSeleccionImagen = (files) => {
		setDatos({ ...datos, imagen: files[0] })
	}

	// render
	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" scroll="true" responsive="lg">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Editar propiedad intelectual" />
			<Offcanvas.Body id="editar-propiedad">
				<h1>Campos de la propiedad intelectual</h1>
				{datos.id && (<Row>
					<Col sm={12} md={6}>
						<Form onSubmit={handleProcesar} className="ms-4">
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="propiedad-borrador">
										<Form.Check
											type="switch"
											label="Publicado"
											checked={!datos.borrador}
											onChange={(e) => handleChange(!e.target.checked, 'borrador')}
										/>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="propiedad-titulo">
										<FormLabel>Título</FormLabel>
										<Form.Control
											value={datos.titulo}
											onChange={(e) => handleChange(e.target.value, 'titulo')}
											isInvalid={erroresValidacion.titulo}
										/>
										<Form.Control.Feedback type="invalid">{erroresValidacion.titulo}</Form.Control.Feedback>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="propiedad-contenido">
										<Form.Label>Contenido</Form.Label>
										<Form.Control
											as="textarea" rows={15}
											value={datos.contenido}
											onChange={(e) => handleChange(e.target.value, 'contenido')}
										/>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Group className="mb-3 col-md-3" controlId="propiedad-fecha">
										<FormLabel>Fecha</FormLabel>
										<DatePicker
											selected={datos.fecha}
											onChange={(fecha) => handleChange(fecha, 'fecha')}
											locale='es'
											dateFormat="dd/MM/yyyy"
										/>
									</Form.Group>
								</Col>
							</Row>
						</Form>
					</Col>
					<Col sm={12} md={6}>
						{propiedadOriginal.imagen && (
							<div className="text-center imagen-actual">
								<h4>Image seleccionada</h4>
								<img src={process.env.REACT_APP_API_URL + propiedadOriginal.imagen.url} alt="Imagen"/>
								<hr className="mb-5" />
							</div>
						)}

						<FileUpload
							title="Imagen"
							accept=".png, .jpg, .jpeg"
							buttonText="Elegir"
							buttonTextSingular="imagen"
							updateFiles={handleSeleccionImagen}
						/>
					</Col>
				</Row>)}
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="outline-tertiary" onClick={handleClose} className="me-2">
					Cancelar
				</Button>
				<Button variant="primary" onClick={handleProcesar}>
					Guardar
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default EditarPropiedad